<template>
<div id="app">
	<Header v-if="showHeader"></Header>
	<!-- <CopyMsgHeader v-else /> -->
    <section id="bd">
    	<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
    </section>
</div>
</template>
<script>
import Header from './components/grantAct/header.vue'
export default {
	name: "App",
  	components:{
    	Header
  	},
		data() {
			return {
				showHeader: true
			}
		},
		created() {
			this.showHeader =	window.location.href.indexOf('copyMsg') > -1 ? false : true
			// this.showHeader =	window.location.href.indexOf('aboutUs') > -1 ? false : true
		}
};
</script>
<style>
@charset "utf-8";
*{margin:0; padding:0;}
html{/*-webkit-tap-highlight-color:transparent; */scroll-behavior:smooth;}
body{font:16px/1.5 "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif; color:#333;}
ul{list-style-type:none;}
h1,h2,h3,h4,h5,h6{font-size:inherit;}
input,button,textarea,select,textarea,th{font:inherit; text-align:inherit; color:inherit;}
label,input,button,select,textarea{box-sizing:border-box; display:inline-block; vertical-align:middle; border-radius:inherit;}
input,button,textarea,select{outline:none;}
table{table-layout:fixed; border-collapse:collapse; border-spacing:0;}
a{color:#333; text-decoration:none;}
a:hover{color:#333;}
img,video,canvas{max-width:100%; vertical-align:middle;}
textarea{overflow:auto; resize:none;}
input::-ms-clear{display:none;}
/*去除input[number]加减*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button{
    -webkit-appearance: none !important;
}
input[type="number"]{-moz-appearance:textfield;}



*,*:before,*:after{background-repeat:no-repeat; background-position:0 center; background-size:100% auto;}
html{font-size:calc(100vw/720*100);}
body{background:rgba(238,238,238,1); color:#515252; font-size:.26rem;}
a{color:#333;}
::-webkit-input-placeholder{
	color:#999;
}
html.on,
html.on body{overflow:hidden;}
input:-webkit-autofill {
	-webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
#app{max-width:720px; margin:0 auto;}
#bd{margin-top:.96rem;}
/*--------------------function--------------------*/
.f-cb:after{content:''; display:table; clear:both;}
.f-tal{text-align:left;}.f-tac{text-align:center;}.f-tar{text-align:right;}
.f-fl{float:left;}.f-fr{float:right;}
</style>



// WEBPACK FOOTER //
// src/App.vue